import React from 'react';
import { Dialog } from "../../../../components/Dialog/Dialog";
import { DialogActions } from "../../../../components/Dialog/DialogActions";
import { DialogButton } from "../../../../components/Dialog/DialogButton";
import { Typography } from "../../../../components/Typography/Typography";
import { useTranslation } from "../../../../hooks/useTranslation";
import { DialogContent } from "../../../../components/Dialog/DialogContent";
import { DialogTitle } from "../../../../components/Dialog/DialogTitle";
import { useLink } from "../../../../hooks/useLink";
import { pathToWorkList } from "../../../../helpers/route-helpers";
import { makeStyles } from "../../../../styles/makeStyles";
var useStyles = makeStyles(function () { return ({
    content: {
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
    },
}); });
export var WorkUnavailableDialog = function (_a) {
    var open = _a.open, workNames = _a.workNames, onClose = _a.onClose;
    var t = useTranslation().t;
    var classes = useStyles();
    var LinkToWorkList = useLink({ href: pathToWorkList(), isTargetBlank: true });
    var handleRef = function (element) {
        element === null || element === void 0 ? void 0 : element.setAttribute('data-test-id', 'WorkUnavailableDialog');
    };
    return (React.createElement(Dialog, { open: open, ref: handleRef },
        React.createElement(DialogTitle, null, t('ワークメーカー')),
        React.createElement(DialogContent, { className: classes.content },
            React.createElement(React.Fragment, null, workNames.map(function (workName, index) {
                return (React.createElement(Typography, { key: workName + "-" + index, variant: "body1" }, workName));
            })),
            React.createElement("br", null),
            React.createElement(Typography, { variant: "body1" }, t('のワークには古い教材が含まれています。')),
            React.createElement(Typography, { variant: "body1" }, t('設定されている問題を確認して、やりなおしてください。')),
            React.createElement(LinkToWorkList, null, t('ワーク一覧画面を開く'))),
        React.createElement(DialogActions, null,
            React.createElement(DialogButton, { onClick: onClose, fill: true }, t('OK')))));
};
